module.exports = __webpack_public_path__ + "static/media/21.045a18cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/21.jpg
// module id = 582
// module chunks = 0